import React from 'react';
import { HStack, Input, SmallCloseIcon, Text } from 'native-base';
import { IconButton } from './IconButton';

export const MultilineInput = ({
  entries,
  onEntriesChange,
  readonly,
  placeholder = null,
}) => {
  if (!entries.length) {
    return (
      <Text italic fontSize={'lg'}>
        No Entries
      </Text>
    );
  }

  return entries.map((value, index) => (
    <HStack alignItems={'center'} key={index} marginBottom={3}>
      <Input
        fontSize={'lg'}
        marginBottom={0}
        maxW={'100%'}
        value={value}
        onChange={(evt) => {
          const newEntries = [
            ...entries.slice(0, index),
            evt.target.value,
            ...entries.slice(index + 1),
          ];

          onEntriesChange(newEntries);
        }}
        isReadOnly={readonly}
        placeholder={placeholder}
      />

      {!readonly && (
        <IconButton
          onClick={() => {
            const newEntries = [
              ...entries.slice(0, index),
              ...entries.slice(index + 1),
            ];

            onEntriesChange(newEntries);
          }}
        >
          <SmallCloseIcon />
        </IconButton>
      )}
    </HStack>
  ));
};
